export default __webpack_public_path__ + "static/media/changes-in-my-life.15b337aa.svg";